import React, { useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';

const InternalRemake = () => {
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [rows, setRows] = useState([]); // You can populate this manually or leave it empty for frontend-only
  const [searchTerm, setSearchTerm] = useState('');
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);

  const filteredRows = rows.filter(row =>
    Object.values(row).some(value =>
      value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const columns = [
    { field: 'id', headerName: 'ID', width: 150 },
    { field: 'name', headerName: 'Name', width: 300 },
    { field: 'amount', headerName: 'Amount', width: 300 },
  ];

  const handleRowClick = (id) => {
    setSelectedRowId(id === selectedRowId ? null : id);
  };

  // Open edit modal with selected row data
  const handleEdit = (id) => {
    const rowData = rows.find(row => row.id === id);
    setSelectedRowData(rowData);
    setIsEditModalOpen(true); // Open the modal when editing
  };

  // Close the edit modal
  const handleModalClose = () => {
    setIsEditModalOpen(false);
    setSelectedRowData(null); // Clear selected row data when closing modal
  };

  // Update rows locally without backend
  const handleSaveChanges = (id) => {
    if (!selectedRowData) {
      console.error("Selected row data is missing");
      return;
    }
    const updatedRows = rows.map(row =>
      row.id === selectedRowData.id ? { ...row, ...selectedRowData } : row
    );
    setRows(updatedRows); // Update the rows in the state
    setIsEditModalOpen(false);
    setSelectedRowData(null); // Reset the selected row data
  };

  return (
    <div>
      <h2 className="title" style={{ border: 'white', borderBottom: '3px solid #004aad', padding: '10px' }}>Internal Remake Types</h2>
      <div className="search">
        <div className="row align-items-center">
          <div className="col-md-9 d-flex justify-content-between">
            <div className="col-md-3 d-flex justify-content-start">
              <input
                type="text"
                id="searchInput"
                className="form-control"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
          <div className="col-md-3 d-flex justify-content-end">
            <Link to="/addInternalRemake" className="btn btn-primary" style={{backgroundColor:"#004aad",borderColor:"#004aad"}}>
              Add
            </Link>
          </div>
        </div>
      </div>
      <div style={{ height: 400, width: '100%', position: 'relative', marginTop: '2%', background: '#f0f0f5' }}>
        <DataGrid
          rows={filteredRows}
          columns={columns}
          pageSize={5}
          onRowClick={(row) => handleRowClick(row.id)}
          components={{ Toolbar: () => null }}
        />
        {selectedRowId !== null && (
          <div style={{
            position: 'absolute',
            top: rows.findIndex(row => row.id === selectedRowId) * 52 + 48,
            right: '10px',
            display: 'flex',
            marginTop: '15px',
          }}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleEdit(selectedRowId)}
              sx={{ marginRight: 1 }}
            >
              Edit
            </Button>
            {/* Delete button removed as it relied on backend */}
          </div>
        )}
      </div>

      {/* Edit Modal */}
      <Dialog open={isEditModalOpen} onClose={handleModalClose}>
        <DialogTitle>Edit Item</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Name"
            fullWidth
            value={selectedRowData === null ? '' : selectedRowData.name}
            onChange={(e) => setSelectedRowData({ ...selectedRowData, name: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Amount"
            fullWidth
            value={selectedRowData === null ? '' : selectedRowData.amount}
            onChange={(e) => setSelectedRowData({ ...selectedRowData, amount: e.target.value })}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleModalClose} color="primary">
            Cancel
          </Button>
          <Button onClick={() => handleSaveChanges(selectedRowData.id)} color="primary">
            Save Changes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default InternalRemake;